// @ts-nocheck
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import WorkspaceTab from './WorkspaceTab';
import CommunicationsTab from './CommunicationsTab';
import BillingTab from './BillingTab';
import ComplianceTab from './ComplianceTab';
import SchedulingTab from './SchedulingTab';
import BusinessKnowledgeTab from './BusinessKnowledgeTab';
import PortalTab from './PortalTab';
import TeamTab from './TeamTab';
import PhoneTab from './PhoneTab';
import AppearanceTab from './AppearanceTab';
import IntegrationsPage from '../../../components/Settings/integrations/IntegrationsPage';
import DocumentCenter from '../../../components/Settings/documents/DocumentCenter';
import AISettingsPage from '../../../components/Settings/ai/AISettings';
import ServiceCatalog from '../../../components/Settings/ServiceCatalog';
import './settings-v2.css';

/* Settings — top tabs like the rest of the app; each tab is a form page:
   sticky section rail + a 720px content column + one save bar.
   FRAME RULE: nothing in Settings navigates out of Settings. Tool pages
   (integrations, documents, ai) render inside this shell. */

const TAB_META = {
  workspace: { title: 'Workspace', sub: 'Company identity, branding, and your tools' },
  communications: { title: 'Communications', sub: 'Sending identity, numbers and templates' },
  phone: { title: 'Phone', sub: 'How the line answers, who it rings, what the assistant may do' },
  billing: { title: 'Billing', sub: 'Plan, payments and invoicing' },
  compliance: { title: 'Compliance', sub: 'Licenses, certifications and insurance your business must hold' },
  portal: { title: 'Customer Portal', sub: 'What customers see when they sign in' },
  scheduling: { title: 'Scheduling', sub: 'Services, hours and time off' },
  knowledge: { title: 'Assistant knowledge', sub: 'What the AI assistant knows about your business' },
  team: { title: 'Team', sub: 'Your people, roles and availability' },
  appearance: { title: 'Appearance', sub: 'Theme and accent color' },
};

/* Tool pages routed from Workspace → More tools. Content is the existing
   page for now — the frame holds; the content gets rebuilt later. */
const TOOL_META = {
  integrations: { title: 'Integrations', sub: 'Connected apps and services', C: IntegrationsPage },
  documents: { title: 'Documents', sub: 'Contracts, waivers and uploads', C: DocumentCenter },
  ai: { title: 'AI assistant', sub: 'Personality and automation level', C: AISettingsPage },
  catalog: { title: 'Service Catalog', sub: 'The services you sell — type, duration, price, recurring', C: ServiceCatalog },
  // 'automations' tab removed: it persisted a rules engine (lead.created → send_sms)
  // into preferences.automation_rules that NOTHING evaluates (event_bus never reads
  // it) — a settings page promising automation we never built. Removed per
  // docs/SETTINGS_NOOP_AUDIT.md #7 rather than shipped half-present.
};


export default function SettingsShell() {
  const navigate = useNavigate();
  const { tab, sub, id } = useParams();

  const tool = TOOL_META[tab];
  const active = tool ? tab : (TAB_META[tab] ? tab : 'workspace');
  const meta = tool || TAB_META[active];

  return (
    <div className="sv2">
      <div className="sv2-head">
        {tool ? (
          <button className="sv2-back" onClick={() => navigate('/settings/workspace')}>
            ← Workspace
          </button>
        ) : null}
        <h1>{meta.title}</h1>
        <span className="sv2-sub">{meta.sub}</span>
      </div>

      {tool ? (
        <div className="sv2-body">
          <div className="sv2-col sv2-col--tool">
            <tool.C />
          </div>
        </div>
      ) : (
        <>
          {active === 'workspace' && <WorkspaceTab />}
          {active === 'communications' && <CommunicationsTab sub={sub} id={id} />}
          {active === 'phone' && <PhoneTab sub={sub} id={id} />}
          {active === 'billing' && <BillingTab />}
          {active === 'compliance' && <ComplianceTab />}
          {active === 'scheduling' && <SchedulingTab sub={sub} id={id} />}
          {active === 'knowledge' && <BusinessKnowledgeTab />}
          {active === 'portal' && <PortalTab />}
          {active === 'team' && <TeamTab />}
          {active === 'appearance' && <AppearanceTab />}
        </>
      )}
    </div>
  );
}
